export enum LocalizationId {
	MEDIA_PLAYER = 'media-player',
}
